import { TaxModuleType } from './types.ts'

interface TaxModuleProps {
  tax_module: TaxModuleType
}

export default function TaxModule({ tax_module }: TaxModuleProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nom :</strong>
        {tax_module.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Couleur :</strong>
        {tax_module.color?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {tax_module.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Actif :</strong>
        {tax_module.active?.toString()}
      </p>
    </div>
  )
}
